import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Divider, IconButton, Typography } from "@mui/material";

import { ArrowBackButtonIcon } from "../../assets/icons/go-hire-icons";
import { useTrendingServices } from "../../api/queries/useTrendingServices";

import ServicesList from "./ServicesList";
import AllServicesTypes from "./AllServicesTypes";
import ServicesPagination from "./ServicesPagination";
import TrendingServicesFilters from "./TrendingServicesFilters";

const TrendingServicesPage = () => {
  const { t, i18n } = useTranslation("goService", {
    keyPrefix: "trendingServicesPage",
  });

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBack = () => {
    navigate(-1);
  };

  const page = Number(searchParams.get("page") || "1");
  const limit = Number(searchParams.get("limit") || "6");

  // Extract filter parameters from URL
  const search = searchParams.get("search") || undefined;
  const role = searchParams.get("role") || undefined;
  const country = searchParams.get("country") || undefined;
  const type = searchParams.get("type") || undefined;
  const category = searchParams.get("category") || undefined;
  const rating = searchParams.get("rating") ? Number(searchParams.get("rating")) : undefined;
  const availability = searchParams.get("availability") || undefined;

  // Map URL params to API params
  const personas = role || undefined;
  const countryIds = country || undefined;
  const categories = category || undefined;
  const availabilityOption = availability || undefined;

  const { data: trendingServices, isLoading: isTrendingServicesLoading } = useTrendingServices({
    limit,
    page,
    search,
    personas,
    countryIds,
    type,
    categories,
    rating,
    availabilityOption,
  });

  const services = trendingServices?.items;
  const meta = trendingServices?.meta;

  return (
    <Box sx={styles.root}>
      <Typography sx={styles.title}>
        <IconButton size="small" onClick={handleBack}>
          <ArrowBackButtonIcon />
        </IconButton>
        {t("title")}
      </Typography>
      {/* <AllServicesTypes isDataLoading={isTrendingServicesLoading} /> */}
      <TrendingServicesFilters isDataLoading={isTrendingServicesLoading} />
      <ServicesList services={services} isDataLoading={isTrendingServicesLoading} meta={meta} />
      {meta && meta.totalPages > 1 && (
        <>
          <Divider sx={styles.divider} orientation="horizontal" />
          <ServicesPagination totalPages={meta.totalPages} />
        </>
      )}
    </Box>
  );
};

export default TrendingServicesPage;

const styles = {
  root: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  divider: {
    borderColor: "#EAECF0",
    margin: "0 -20px",
  },
};
